import React from 'react';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Toolbar from '@material-ui/core/Toolbar';
import Router from 'components/Router/Router';
import Icon from 'components/Icons/';
import { useAuth } from 'providers/AuthProvider/SessionAuthProvider';
import Header from '../Header/Header';
import SubHeader from '../Header/SubHeader';
import Breadcrumbs from '../Header/Breadcrumbs';
import CacheCheck from 'utils/CacheCheck';
const { Link, useParams } = Router;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      backgroundColor: '#EEEEEE',
      minHeight: '100vh',
      flexDirection: 'column',
      justifyContent: 'flex-start'
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      height: '69px',
      backgroundColor: 'white',
      boxShadow: 'none'
    },
    toolBar: {
      height: '69px',
      display: 'flex',
      justifyContent: 'space-between',
      paddingLeft: 0,
      paddingRight: 0
    },
    content: {
      flexGrow: 1,
      position: 'relative'
    },
    wrap: {
      width: '100%',
      paddingLeft: '42px',
      paddingRight: '42px',
      '@media (max-width: 1200px)': {
        paddingLeft: '20px',
        paddingRight: '20px'
      },
      '@media (max-width: 800px)': {
        paddingLeft: '5px',
        paddingRight: '5px'
      }
    },
    toolbar: {
      ...theme.mixins.toolbar,
      paddingLeft: 0
    },
    noneBoxShadow: {
      boxShadow: 'none'
    },
    user: {
      fontWeight: 400,
      color: 'black'
    },
    outBtn: {
      padding: '0.5rem 1rem',
      height: 'auto'
    },
    logo: {},
    breadcrumbWrapper: {
      backgroundColor: 'white',
      zIndex: 1
    }
  })
);

interface DashboardProps {
  children: any;
  disableBoxShadow?: boolean;
  wrapBreadcrumbs?: boolean;
}

const Dashboard = ({
  children,
  disableBoxShadow,
  wrapBreadcrumbs
}: DashboardProps) => {
  const classes = useStyles();
  const { isAuthenticated } = useAuth();
  const { portfolio } = useParams() as any;
  const isCaseSeleted = !!portfolio;

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="relative"
        className={`${classes.appBar} ${
          disableBoxShadow && classes.noneBoxShadow
        }`}
      >
        <Toolbar className={classes.toolBar}>
          {isAuthenticated && <Header />}
          <div style={{ marginLeft: isAuthenticated ? '0' : '1.5rem' }}>
            {!isAuthenticated && (
              <Link className={classes.logo} to="/">
                <Icon.Logo />
              </Link>
            )}
          </div>
        </Toolbar>
      </AppBar>
      {isAuthenticated && <SubHeader />}
      {isAuthenticated && <CacheCheck />}
      {isCaseSeleted && (
        <div
          className={`${classes.wrap} ${
            wrapBreadcrumbs ? classes.breadcrumbWrapper : ''
          }`}
        >
          <Breadcrumbs />
        </div>
      )}
      <main className={`${classes.content} ${classes.wrap}`}>{children}</main>
    </div>
  );
};

export default Dashboard;
